"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var time = new Date().getTime();
var UserInfo = function UserInfo(_ref) {
  var config = _ref.config;
  return /*#__PURE__*/_react["default"].createElement("iframe", {
    referrerPolicy: "unsafe-url",
    src: "".concat(config.url_base_oauth2, "/MenuMeusDados?v=").concat(time),
    style: {
      width: '100%',
      height: '100%',
      border: 0,
      position: 'absolute'
    }
  });
};
var _default = UserInfo;
exports["default"] = _default;